import axiosInstance from '../utils/axios';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { SimpleTreeView } from '@mui/x-tree-view';
import { TreeItem } from '@mui/x-tree-view';
import FolderIcon from '@mui/icons-material/Folder';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import { Box, Typography } from '@mui/material';
import "./DirectoryTreeComponent.css"

const DirectoryTreeView = ({ asset_type }) => {
    const { type } = useParams();
    const [directories, setDirectories] = useState([]);
    const [expanded, setExpanded] = useState([]);
    const [dragOverNode, setDragOverNode] = useState(null);
    const [visibleAssetType, setVisibleAssetType] = useState("");

    // Get the environment variable for the subdomain
    const subdomain = process.env.REACT_APP_SHADOWSTREAM_SUB || 'genflux';


    useEffect(() => {
        const fetchDirectories = async () => {
            try {
                let asset_type = type.charAt(0).toUpperCase() + type.slice(1);  // Inventory vs inventory -- need to make it insensitive on the server side
                setVisibleAssetType(asset_type);
                const response = await axiosInstance.get(`https://${subdomain}-server.shadowstream.world/api/issue_configurations/?status=ACTIVE&config_type=${asset_type}`);
                const directories = response.data;

                // Automatically expand all nodes
                const expandedNodes = directories.map(dir => dir.config_directory);
                setDirectories(directories);
                setExpanded(expandedNodes);                
            } catch (error) {
                console.error('Error fetching directories:', error);
            }
        };

        fetchDirectories();
    }, [type]);

    const handleToggle = (event, nodeIds) => {
        setExpanded(nodeIds);
    };

    const handleDrop = async (event, config_directory) => {
        event.preventDefault();
        event.stopPropagation(); // Prevent the event from bubbling up to parent nodes
        setDragOverNode(null); // Reset the drag over state

        const files = event.dataTransfer.files;
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
    
            // Prepare form data to send the file and config_directory to the server
            const formData = new FormData();
            formData.append('file', file);
            formData.append('config_directory', config_directory);  // Send the config_directory name
    
            // Upload file to the Django server using Axios
            const response = await axiosInstance.post('/v1/upload_file_to_shadowstream', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.ok) {
                console.log(`Uploaded file: ${file.name} to config_directory: ${config_directory}`);
                alert(file + ' successfully uploaded to shadowstream')
            } else {
                console.error('Error uploading file:', response.statusText);
            }
        }
    };

    const renderTreeItems = (nodes) => {
        const tree = {};

        // if (nodes.length == 0) {
        //     return;
        // } 
        nodes.forEach((node) => {
            const parts = node.config_directory.split('/');
            parts.reduce((acc, part, index) => {
                if (!acc[part]) {
                    acc[part] = {
                        id: node.id,
                        children: {},
                        config_directory: parts.slice(0, index + 1).join('/'),
                    };
                }
                return acc[part].children;
            }, tree);
        });

        const buildTree = (treeNodes) => {

            const sortedEntries = Object.entries(treeNodes).sort(([a], [b]) => a.localeCompare(b));

            return sortedEntries.map(([key, value]) => (
            // return Object.entries(treeNodes).map(([key, value]) => (
                <TreeItem
                    key={value.config_directory}
                    itemId={value.config_directory}
                    label={
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                backgroundColor: dragOverNode === value.config_directory ? 'lightgreen' : 'transparent',
                                padding: '2px 4px',
                                borderRadius: '4px'
                            }}
                        >
                            {expanded.includes(value.config_directory) ? <FolderOpenIcon sx={{ mr: 1 }} /> : <FolderIcon sx={{ mr: 1 }} />}
                            {key}
                        </Box>
                    }
                    onDrop={(e) => handleDrop(e, value.config_directory)}
                    onDragOver={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setDragOverNode(value.config_directory); // Set the current drag over node
                    }}
                    onDragLeave={() => setDragOverNode(null)} // Reset when leaving the node
                >
                    {buildTree(value.children)}
                </TreeItem>
            ));
        };

        return buildTree(tree);
    };

    return (
        <div className="lot-inventory-parent-container"  >
            <div className="lot-inventory-container">
                <div className="ag-theme-alpine" style={{ height: 600, width:1200, marginBottom:50 }}>
  
                    <Box sx={{ height: 500, padding:"20px", flexGrow: 1, overflowY: 'auto' }}>
                        <Typography variant="h6" gutterBottom>
                            {visibleAssetType} Deposition Tree
                        </Typography>
                        <SimpleTreeView
                            expanded={expanded}
                            onNodeToggle={handleToggle}
                            defaultCollapseIcon={<FolderOpenIcon />}
                            defaultExpandIcon={<FolderIcon />}
                        >
                            {renderTreeItems(directories)}
                        </SimpleTreeView>
                    </Box>

              </div>
          </div>
      </div>
    );
};

export default DirectoryTreeView;
